import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import { appDomain } from "../../domain/AppDomain";
import { AppRoutes } from "../../domain/navigation/AppRoutes";
import { IAttentionDay, KindOfAttentionDay } from "../../domain/attentiondays/IAttentionDay";
import { DatePickerCustomInput } from "../basic/DatePickerCustomInput";
import { TextInput } from "../basic/TextInput";
import { BaseComponent } from "../core/BaseComponent";
import "./AttentionDayDetail.css";

type ILabelOption = { id: KindOfAttentionDay, label: string };
interface AttentionDayDetailProps { attentionDayId: string; }
interface AttentionDayDetailState { id?: string; attentionDay: IAttentionDay; isChanged: boolean; selectedOption: ILabelOption }

const kinds: ILabelOption[] = [{ id: KindOfAttentionDay.Holiday, label: "Vakantie" }, { id: KindOfAttentionDay.AttentionDay, label: "Speciale dag" }];

export class AttentionDayDetail extends BaseComponent<AttentionDayDetailProps, AttentionDayDetailState> {
    constructor(props: AttentionDayDetailProps) {
        super(props);
        this.state = {
            attentionDay: {} as IAttentionDay,
            selectedOption: {} as ILabelOption,
            isChanged: false
        };
    }

    componentDidMount() {
        this.getById();
    }

    componentDidUpdate() {
        if (this.state.isChanged) {
            this.setStateWhenMounted({ isChanged: false })
            this.getById();
        }
    }

    async getById() {
        if (this.props.attentionDayId && Number(this.props.attentionDayId) > 0) {
            const attentionDay = await appDomain.IAttentionDayService.requestById(this.props.attentionDayId);
            this.updateSelection(attentionDay.kind);
            this.setStateWhenMounted({ attentionDay });
        }
    }

    private updateSelection(kindOfAttentionDay: KindOfAttentionDay) {
        var selectedOption = kinds.filter(x => x.id === kindOfAttentionDay)[0];
        this.setStateWhenMounted({ selectedOption });
    }

    static getDerivedStateFromProps(nextProps: AttentionDayDetailProps, prevState: any): AttentionDayDetailState | null {
        if (prevState != null && prevState.id !== nextProps.attentionDayId) {
            return { id: nextProps.attentionDayId, isChanged: true, attentionDay: {} as IAttentionDay, selectedOption: {} as ILabelOption };
        }
        return null;
    }

    updateKind(data: any) {
        const attentionDay = this.state.attentionDay;
        this.updateSelection(data.id);
        this.setStateWhenMounted({ attentionDay: { ...attentionDay, kind: data.id } });
    }

    updateDescription(name: string) {
        const attentionDay = this.state.attentionDay;
        this.setStateWhenMounted({ attentionDay: { ...attentionDay, name } });
    }

    updateStartDate(start: Date) {
        const attentionDay = this.state.attentionDay;
        if (!attentionDay.end || start > attentionDay.end) {
            this.state.attentionDay.end = start;
        }
        this.setStateWhenMounted({ attentionDay: { ...attentionDay, start } });
    }

    updateEndDate(end: Date) {
        const attentionDay = this.state.attentionDay;
        if (!attentionDay.start || end < attentionDay.start) {
            attentionDay.start = end;
        }
        this.setStateWhenMounted({ attentionDay: { ...attentionDay, end } });
    }

    async save() {
        if (this.state.attentionDay.id) {
            await appDomain.IAttentionDayService.requestUpdateAttentionDay(this.state.attentionDay);
        } else {
            await appDomain.IAttentionDayService.requestCreateAttentionDay(this.state.attentionDay)
        }

        this.goToList();
    }

    async goToList() {
        this.navigateTo(AppRoutes.attentiondays);
    }

    render() {
        return <div>
            <TextInput label={this.translate("attentiondays.description")} name="description" value={this.state.attentionDay.name} onChange={this.updateDescription.bind(this)} />
            <label>
                <span className="field">{this.translate("attentiondays.kind")}</span>
                <Select
                    value={this.state.selectedOption}
                    onChange={this.updateKind.bind(this)}
                    getOptionValue={(x: any) => x.id}
                    getOptionLabel={(x: any) => x.label}
                    options={kinds}
                />
            </label>
            <label>
                <span className="field">{this.translate("general.start")}</span>
                <DatePicker
                    customInput={<DatePickerCustomInput />}
                    todayButton={"Vandaag"}
                    locale="nl-NL"
                    selected={this.state.attentionDay.start}
                    onChange={this.updateStartDate.bind(this)}
                    dateFormat="iiii d MMMM yyyy"
                />
            </label>
            <label>
                <span className="field">{this.translate("general.end")}</span>
                <DatePicker
                    customInput={<DatePickerCustomInput />}
                    todayButton={"Vandaag"}
                    locale="nl-NL"
                    selected={this.state.attentionDay.end}
                    onChange={this.updateEndDate.bind(this)}
                    dateFormat="iiii d MMMM yyyy"
                />
            </label>


            <button className="default-button clickable" onClick={this.goToList.bind(this)}>{this.translate("general.cancel")}</button>
            <button className="default-button clickable float-right" onClick={this.save.bind(this)}>{this.translate("general.save")}</button>
        </div>
    }
}
